import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Typography } from '@material-ui/core';

const convertBnsToPromptString = (meetingBns) => {
  const bnsIdMeta = meetingBns.meta().field('bestNextStepId').options().map();
  return meetingBns
    .resources()
    .list()
    .map(bns => bnsIdMeta[bns.attr('bestNextStepId')].attr('prompt'))
    .join(', ');
};

const styles = () => ({
  root: {},
});

const AcceptedContentTooltip = ({
  className,
  classes,
  eventTitle,
  bestNextSteps,
  timeRange,
}) => {
  return (
    <div className={classNames(className, classes.root)}>
      <Typography>
        {eventTitle}
        <br />
        {bestNextSteps.length > 0 && (
          <>
            {`Best Next Steps: ${convertBnsToPromptString(bestNextSteps)}`}
            <br />
          </>
        )}
        {timeRange}
      </Typography>
    </div>
  );
};

AcceptedContentTooltip.defaultProps = {
  className: '',
};

AcceptedContentTooltip.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  eventTitle: PropTypes.string.isRequired,
  bestNextSteps: PropTypes.array.isRequired,
  timeRange: PropTypes.string.isRequired,
};

export default withStyles(styles)(AcceptedContentTooltip);
